import { SET_PASSENGERS_CONFIG } from './actions';
export const passengersConfigReducer = (state = {}, action) => {
    if (action.type === SET_PASSENGERS_CONFIG) {
        return action.payload;
    }
    return state;
};
